import Endpoints from 'constants/Endpoints';
import {RestRequestBLOB, RestRequestGET, RestRequestPOST} from 'libs/RestRequest';
import reduxStore from 'redux/store'
import {clearResource, setResource, setSaveStatusError} from "../redux/actions";
import isResponseValid from "../libs/isResponseValid";
import Tr from "../translations/Translations";
import RouterPath from "../libs/RouterPath";
import isResponseValidWithStoredPasswordCheck from "../libs/isResponseValidWithStoredPasswordCheck";
import downloadFile from "../libs/downloadFile";
import DemandOffersService from "./DemandOffersService";
import DemandOffersOfferService from "./DemandOffersOfferService";
import {StageSections} from "../pages/contractor/demand/scenes/offer/constants/StageSections";


const OFFER_AUCTIONS_LIST_DATA = "offerAuctionsListData";
const AUCTIONS_OFFER_EDIT = "auctionOfferEdit";
const AUCTIONS_OFFER_POSITIONS_LOADED = "auctionOfferPositionsLoaded";

const getOfferAuctionsList = async (demandId, stageId) => {
    try {
        const resp = await RestRequestGET(Endpoints.DEMAND_ADDITIONAL_AUCTIONS_OFFER_AUCTIONS(demandId, stageId));
        if (isResponseValid(resp,
            () => defErrorCallback(demandId, stageId)
        )) {
            reduxStore.dispatch(setResource(OFFER_AUCTIONS_LIST_DATA, resp.result));
        }
    } catch (e) {
        console.error(e);
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')));
    }


}

const assignToAuction = async (demandId, stageId, auctionId) => {
    try {
        return await RestRequestPOST(Endpoints.DEMAND_ADDITIONAL_AUCTIONS_OFFER_AUCTIONS_ASSIGN(demandId, stageId, auctionId));
    } catch (e) {
        console.error(e);
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')));
    }
}

const getOfferEdit = async (demandId, stageId, mode, supplierId) => {
    try {
        const params = {supplierId}
        const resp = await RestRequestGET(Endpoints.DEMAND_ADDITIONAL_AUCTIONS_OFFER_MODE(demandId, stageId, mode, supplierId), {params});
        if (isResponseValid(resp,
            () => defErrorCallback(demandId, stageId)
        )) {
            reduxStore.dispatch(setResource(AUCTIONS_OFFER_EDIT, resp.result))
        }
    } catch (e) {
        console.error(e);
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')));
    }
}

const getDownloadEspdFile = async (demandId, stageId, mode, fileId, supplierId) => {
    try {
        const params = {supplierId}
        const resp = await RestRequestGET(Endpoints.DEMAND_ADDITIONAL_AUCTIONS_OFFER_MODE_ESPD_DOWNLOAD_URL(demandId, stageId, mode, fileId, supplierId), {params});
        if (isResponseValidWithStoredPasswordCheck(resp,
            () => getDownloadEspdFile(demandId, stageId, mode, fileId, supplierId),
            () => {
            }
        )) {
            downloadFile({url: resp.result})
        }
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')));
    }
}
const getDownloadOfferFile = async (demandId, stageId, mode, fileId, supplierId) => {
    try {
        const params = {supplierId}
        const resp = await RestRequestGET(Endpoints.DEMAND_ADDITIONAL_AUCTIONS_OFFER_MODE_FILE_DOWNLOAD_URL(demandId, stageId, mode, fileId, supplierId), {params});
        if (isResponseValidWithStoredPasswordCheck(resp,
            () => getDownloadOfferFile(demandId, stageId, mode, fileId, supplierId),
            () => {
            }
        )) {
            downloadFile({url: resp.result})
        }
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')));
    }
}


const getOfferPosition = async (demandId, stageId, mode, positionId, supplierId) => {
    try {
        const params = {supplierId}
        const resp = await RestRequestGET(Endpoints.DEMAND_ADDITIONAL_AUCTIONS_OFFER_MODE_POSITION_ID(demandId, stageId, mode, positionId, supplierId), {params});
        if (isResponseValidWithStoredPasswordCheck(resp,
            () => getOfferPosition(demandId, stageId, mode, positionId, supplierId),
            () => defErrorCallback(demandId, stageId, supplierId)
        )) {
            const {resources} = reduxStore.getState();
            const loaded = resources[AUCTIONS_OFFER_POSITIONS_LOADED] || {};

            const newLoaded = {
                ...loaded,
                [getLoadedPositionKey(positionId)]: resp.result
            }

            reduxStore.dispatch(setResource(AUCTIONS_OFFER_POSITIONS_LOADED, newLoaded))
        }
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')));
    }
}

const postSavePositionData = async (demandId, stageId, supplierId, mode, data) => {
    let errorsAndAlerts;
    try {
        const params = {supplierId}
        const resp = await RestRequestPOST(Endpoints.DEMAND_ADDITIONAL_AUCTIONS_OFFER_POSITION(demandId, stageId, supplierId), data, {params});

        if (isResponseValidWithStoredPasswordCheck(resp,
            () => postSavePositionData(demandId, stageId, supplierId, mode, data),
            () => defErrorCallback(demandId, stageId, supplierId),
            (err) => {
                errorsAndAlerts = err;
            }, true
        )) {
            const {resources} = reduxStore.getState();
            const loaded = resources[AUCTIONS_OFFER_POSITIONS_LOADED] || {};
            const newLoaded = {
                ...loaded,
                [getLoadedPositionKey(data.positionId)]: {
                    ...data,
                    placingType: null
                }
            }
            reduxStore.dispatch(setResource(AUCTIONS_OFFER_POSITIONS_LOADED, newLoaded))
            let filesResp = null;
            if (data.placingType) {
                filesResp = await RestRequestGET(Endpoints.DEMAND_ADDITIONAL_AUCTIONS_OFFER_MODE_FILES(demandId, stageId, mode, supplierId), {params});
            }

            const curEdit = resources[AUCTIONS_OFFER_EDIT];
            const edit = {
                ...curEdit,
                positions: curEdit.positions.map(x => x.positionId === resp.result.positionId ? resp.result : x)
            }
            if (filesResp?.success) {
                edit.offerFiles = filesResp.result;
            }
            reduxStore.dispatch(setResource(AUCTIONS_OFFER_EDIT, edit));
            await DemandOffersService.getStageSection(demandId, stageId, StageSections.AUCTION_OFFER_PLACED, supplierId);
        }
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')));
    }

    if(Array.isArray(errorsAndAlerts)) {
        if(errorsAndAlerts.length > 0) {
            if(typeof errorsAndAlerts[0] === 'string' || errorsAndAlerts[0] instanceof String) {
                reduxStore.dispatch(setSaveStatusError(errorsAndAlerts[0]))
            }
        } else {
            reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')));
        }
    }
    return errorsAndAlerts;
}

const getSnapshots = async (demandId, stageId, positionId, supplierId) => {
    try {
        const params = {supplierId}
        const resp = await RestRequestGET(Endpoints.DEMAND_ADDITIONAL_AUCTIONS_OFFER_SNAPSHOTS(demandId, stageId, positionId, supplierId), {params});
        if (isResponseValid(resp, (e) => {
            throw new Error(e)
        })) {
            return resp.result;
        }
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')));
    }
}

const downloadSnapshot = async (demandId, stageId, positionId, snapshotId, supplierId) => {
    try {
        const params = {supplierId}
        const resp = await RestRequestBLOB(Endpoints.DEMAND_ADDITIONAL_AUCTIONS_OFFER_SNAPSHOT_ID(demandId, stageId, positionId, snapshotId, supplierId), {params});

        if (resp && isResponseValidWithStoredPasswordCheck(resp,
            () => downloadSnapshot(demandId, stageId, positionId, snapshotId, supplierId),
            () => defErrorCallback(demandId, stageId)
        )) {
            return resp.result;
        }
        return true;
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')));
    }
}

const defErrorCallback = (demandId, stageId, supplierId) => {

    if (supplierId) {
        const {resources} = reduxStore.getState()
        if (resources[DemandOffersService.DEMAND_STAGES_LIST]) {
            const stage = resources[DemandOffersService.DEMAND_STAGES_LIST].find(x => x.supplierId === supplierId);
            if (stage?.contractorDepartmentId) {
                RouterPath.redirectWithoutHistory(RouterPath.createPath(RouterPath.purchaserDemand.PURCHASER_DEMAND_ID_OFFER_CONTRACTOR_ID_STAGE_ID, {
                    id: demandId,
                    contractorDepartmentId: stage.contractorDepartmentId,
                    stageId
                }));
            }
        }
    } else {
        RouterPath.redirectWithoutHistory(RouterPath.createPath(RouterPath.ctrDemand.steps.CTR_DEMAND_ID_OFFER_STAGE_ID, {
            id: demandId,
            stageId
        }));
    }
}

const getLoadedPositionKey = DemandOffersOfferService.getLoadedPositionKey;

const clearResources = (resId) => reduxStore.dispatch(clearResource(resId));

export default {
    getOfferAuctionsList,
    assignToAuction,

    getOfferEdit,
    getDownloadEspdFile,
    getDownloadOfferFile,
    getOfferPosition,
    postSavePositionData,
    getSnapshots,
    downloadSnapshot,
    getLoadedPositionKey,
    clearResources,
    OFFER_AUCTIONS_LIST_DATA,
    AUCTIONS_OFFER_EDIT,
    AUCTIONS_OFFER_POSITIONS_LOADED
}